import { EToastType, toast } from '@bfe/moly';
import React, { useEffect, useState } from 'react';

import BySecurity from '@/components/NewSecurity';
import { useI18nContext } from '@/i18n/I18n';
import { getRiskStrategyApi } from '@/services/security';
import { SecurityComponentTrack } from '@/utils/trace-list/security-component';

interface IProps {
  scene?: string;
  risk_token?: string;
  showFailToast?: boolean;
  onSuccess: (risk_token: string) => void;
  onClose: (risk_token_type?: string, riskToken?: string) => void;
  onFail?: (error: any) => void;
  ext_info_str?: string | { [key: string]: any };
  onGetRiskTokenFail?: (e: any) => void;
  closeCallbackAfterSuccess?: boolean;
}

const SecurityComponent = ({
  scene,
  risk_token,
  showFailToast = true,
  onSuccess,
  onFail,
  onClose,
  ext_info_str,
  onGetRiskTokenFail,
  closeCallbackAfterSuccess = true,
}: IProps) => {
  const [$t] = useI18nContext();

  const [showRiskToken, setShowRiskToken] = useState(risk_token);
  const [riskTokenType, setRiskTokenType] = useState('');

  const getStrategy = async (
    scene: string,
    ext_info_str?: string | { [key: string]: any },
  ) => {
    try {
      const rs: any = await getRiskStrategyApi({ sence: scene, ext_info_str });
      const {
        result: { risk_token, risk_token_type },
      } = rs;
      if (risk_token_type === 'pass') {
        onSuccess(risk_token);
        onClose();
      } else if (risk_token) {
        setShowRiskToken(risk_token);
        setRiskTokenType(risk_token_type);
      }
    } catch (error: any) {
      if (showFailToast) {
        const title =
          typeof error?.ret_msg === 'string' && error?.ret_msg !== ''
            ? error?.ret_msg
            : $t('networkError');
        toast({
          iconType: EToastType.WARN,
          title,
        });
      }
      if (typeof onGetRiskTokenFail === 'function') {
        onGetRiskTokenFail(error);
      } else {
        onFail?.(error);
        onClose();
      }
      SecurityComponentTrack(scene, 'default-intercept', error);
    }
  };

  useEffect(() => {
    // 传入 risk_token 时，只做安全组件校验，不需要获取新的 risk_token
    if (!risk_token && scene) {
      getStrategy(scene, ext_info_str);
    } else if (risk_token && !scene) {
      setShowRiskToken(risk_token);
    }
  }, [risk_token, scene, ext_info_str]);

  useEffect(() => {
    return () => {
      setShowRiskToken('');
    };
  }, []);

  if (!showRiskToken) {
    return null;
  }

  return (
    <BySecurity
      key={showRiskToken}
      risk_token={showRiskToken}
      closeCallbackAfterSuccess={closeCallbackAfterSuccess}
      faceFailHandler={() => {
        setShowRiskToken('');
        onClose?.();
      }}
      clearTokenHandler={() => {
        setShowRiskToken('');
        onClose?.(riskTokenType, showRiskToken);
      }}
      callBack={(res: any) => {
        onSuccess?.(res?.result.risk_token);
        setShowRiskToken('');
      }}
    />
  );
};

export default SecurityComponent;
